import { useMeiliSearchRef } from "./useMeiliSearchRef.js";
import { useState } from "#imports";
export function useMeiliSearch(index) {
  if (!index)
    throw new Error("`[nuxt-meilisearch]` Cannot search  without `index`");
  const client = useMeiliSearchRef();
  const result = useState(`${index}-search-result`, () => null);
  const search = async (query, searchParams) => {
    const resp = await client.index(index).search(query, searchParams);
    result.value = resp;
    return resp;
  };
  return {
    search,
    result
  };
}
